module.exports = __webpack_public_path__ + "assets/0062f59f8837fe3d1485faf5c41e1531.png";